
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimi-checker",
      function () {
        return require("private-next-pages/bimi-checker.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimi-checker"])
      });
    }
  